<template>
  <div>
    <b-form ref="newRecordForm" id="newRecordFormKKEBudgets">
      <b-table
        :items="allocations"
        fixed
        small
        bordered
        class="bg-white budgetSourcesTable sum-header"
        :fields="allocationsFields"
        head-variant="light"
        show-empty
        :busy="tableIsBusy"
        sticky-header="613px"
      >
        <template #empty>
          <div class="block text-center text-muted">Keine Budgetierungen vorhanden.</div>
        </template>
        <template #head(Amount)="data">
          <div style="padding-right:11px">
            {{ data.label }}
          </div>
          <div class="font-weight-bold text-grey">
            {{ formatCurrency(costGroupAllocatedBudget) }}
          </div>
        </template>
        <template #cell(Target)>
          VE
        </template>
        <template #head(Ratio)="data">{{ data.label }}</template>
        <!---------------------------------
                    EDIT FIELD  R A T I O
                ---------------------------------->
        <template #cell(Ratio)="data">
          <div
            :class="{ 'action-button': $root.$user.isPlaner || $root.$user.isAdmin }"
            style="padding-right: 9px"
            v-if="!data.item.editMode"
            @click="editAllocation(data.item, 'ratioField')"
          >
            {{ $utils.numberWithMaxFrictionsDE((data.item.Amount / costGroupTotalBudget) * 100, 1) }} %
          </div>
          <b-input-group append="%" v-if="data.item.editMode">
            <input
              :required="data.item.editMode"
              v-model="data.item.Ratio"
              class="form-control table-input-field px-2 text-right"
              :ref="'ratioField-' + data.item.Id"
              :name="'ratioField-' + data.item.Id"
              :id="'ratioField-' + data.item.Id"
              @keydown.enter="updateAllocationItem(data.item)"
              @keydown.esc="cancelRowEdit(data.item)"
              placeholder="Anteil"
              type="number"
              min="1"
              step="100"
              @input="
                onEditRowRatioChanged(data.item);
                evalRowIsDirty(data.item);
              "
            />
          </b-input-group>
        </template>
        <!---------------------------------
            EDIT FIELD A M O U N T
        ---------------------------------->
        <template #cell(Amount)="data">
          <div
            :class="{ 'action-button': $root.$user.isPlaner || $root.$user.isAdmin }"
            style="padding-right: 9px"
            v-show="!data.item.editMode"
            @click="editAllocation(data.item, 'budgetAmountField')"
          >
            {{ formatCurrency(data.item.Amount) }}
          </div>
          <b-input-group append="€" v-if="data.item.editMode">
            <input
              :required="data.item.editMode"
              v-model="data.item.Amount"
              class="form-control table-input-field px-2 text-right"
              :ref="'budgetAmountField-' + data.item.Id"
              :name="'budgetAmountField-' + data.item.Id"
              :id="'budgetAmountField-' + data.item.Id"
              @keydown.esc="cancelRowEdit(data.item)"
              @keydown.enter="updateAllocationItem(data.item)"
              @keydown.tab.exact.stop="updateAllocationItem(data.item)"
              @input="
                onEditRowValueChanged(data.item);
                evalRowIsDirty(data.item);
              "
              placeholder="Betrag"
              type="number"
              min="0.01"
              step="0.01"
              pattern="^\d+(?:\.\d{1,2})?$"
            />
          </b-input-group>
        </template>
        <template #cell(actions)="data">
          <!--- E D I T  --->
          <b-icon
            v-if="!data.item.editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="pencil"
            variant="grey"
            class="action-button mr-2"
            @click="editAllocation(data.item)"
          ></b-icon>
          <!--- D E L E T E  --->
          <b-icon
            v-if="!data.item.editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="trash"
            variant="grey"
            class="action-button mr-2"
            @click="deleteAllocation(data.item)"
          ></b-icon>
          <!--- C O M M E N T  --->
          <b-icon
            v-if="!data.item.editMode && ($root.$user.isPlaner || $root.$user.isAdmin)"
            icon="info-circle"
            variant="grey"
            class="action-button"
            @click="editComment(data.item)"
          ></b-icon>
          <!--- A C C E P T   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
          <b-icon
            v-show="data.item.editMode"
            title="Bearbeiten"
            icon="check2"
            variant="grey"
            class="action-button mr-2"
          ></b-icon>
          <!--- C A N C E L   ACTION: ONLY VISIBLE, IF ENTRY IS IN EDIT MODE --->
          <b-icon
            v-show="data.item.editMode"
            title="Bearbeiten abbrechen"
            icon="x"
            variant="grey"
            class="action-button"
          ></b-icon>
        </template>
        <template #custom-foot="">
          <!---------------------------------
                    NEW RECORD ROW
                ---------------------------------->
          <b-tr
            style="border-top: 2px solid #dee2e6;border-bottom: 2px solid #dee2e6;"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          >
            <b-td class="align-middle table-edit-field">VE</b-td>
            <b-td class="p-0 align-middle table-edit-field" colspan="2">
              <!--- FIELD   Q U E L L E --->
              <b-form-select
                required
                v-model="newBudgetAllocationRecord.DbId"
                :options="sourcesWithBudget"
                text-field="DisplayText"
                value-field="DbId"
                class="mr-2 border-0 shadow-none table-edit-field"
                id="input-select-1"
                placeholder="Kostenkontrolleinheit"
                ref="newRecordSourceField"
                @change="onSourceChanged"
              ></b-form-select>
            </b-td>
            <b-td class="p-0 align-middle table-edit-field">
              <!--- FIELD P R O Z E N T --->
              <b-input-group append="%">
                <b-input
                  v-model="newBudgetAllocationPercentage"
                  placeholder="Anteil"
                  type="number"
                  min="0"
                  max="100"
                  ref="allocationRatioField"
                  step=".1"
                  class="text-right border-0 shadow-none table-edit-field"
                  @keydown.enter.prevent.stop="createBudgetAllocation"
                  @keyup.esc="newBudgetAllocationPercentage = null"
                  @change="onNewRecordRowPercentValueChanged"
                />
              </b-input-group>
            </b-td>
            <b-td class="p-0 align-middle table-edit-field">
              <!--- FIELD B E T R A G --->
              <b-input-group append="€">
                <b-input
                  v-model="newBudgetAllocationAmount"
                  placeholder="Betrag"
                  required
                  type="number"
                  min="0.01"
                  step="0.01"
                  pattern="^\d+(?:\.\d{1,2})?$"
                  ref="allocationAmountField"
                  class=" text-right border-0 shadow-none table-edit-field"
                  @keydown="clearCustomValidity"
                  @keydown.enter.prevent.stop="createBudgetAllocation"
                  @keyup.esc="newBudgetAllocationAmount = null"
                  @change="onNewRecordRowAmountValueChanged"
                  @keydown.tab.prevent.stop="$refs['newRecordSourceField'].focus()"
                />
              </b-input-group>
            </b-td>
            <b-td class="py-0 align-middle table-edit-field text-center">
              <!--- A C C E P T   --->
              <b-icon
                icon="check2"
                variant="grey"
                @click="createBudgetAllocation"
                title="Neue Zuordnung speichern"
                class="action-button"
              />
              <b-icon
                icon="x"
                variant="grey"
                @click="clearNewRecordFields"
                title="Neue Zuordnung abbrechen"
                class="action-button"
              />
            </b-td>
          </b-tr>
        </template>
      </b-table>
    </b-form>
    <!---
    currentEditedRow {{ currentEditedRow }}
    <br />
    rowDataBackup {{ rowDataBackup }}
    <br />
    rowIsDirty {{ rowIsDirty }}
    <br />
    fieldsBackup {{ fieldsBackup }}
    --->
    <EditCommentDialog
      :allocation="currentAllocation"
      :source="currentCostGroup"
      sourceDesc="Quelle (KKE)"
      modalId="EditBudgetCommentModal"
    />
  </div>
</template>

<script>
import CostGroupsService from '@/service/CostGroupsService';
import settingsStore from '@/store/Settings';
import EditCommentDialog from '@/components/budget/CommentDialog';

export default {
  components: { EditCommentDialog },
  data() {
    return {
      currentCostGroup: null,
      fieldsBackup: null,
      rowIsDirty: null,
      currentEditedRow: null,
      currentAllocation: {
        RefDbId: null
      },
      allocations: [],
      allocationsFields: [
        {
          key: 'Target',
          label: 'Ziel',
          thClass: 'align-top noselect',
          thStyle: 'width:100px',
          tdClass: 'align-middle'
        },
        {
          key: 'Ordinal',
          label: 'Nr',
          thClass: 'align-top noselect',
          tdClass: 'align-middle',
          thStyle: 'width:150px',
          sortable: true
        },
        {
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top noselect',
          tdClass: 'align-middle',
          sortable: true
        },
        {
          key: 'Ratio',
          label: 'Anteil',
          thStyle: 'width:200px',
          thClass: 'align-top noselect',
          tdClass: 'align-middle text-right p-0',
          sortable: true
        },
        {
          key: 'Amount',
          label: 'Zugewiesen',
          thClass: 'align-top text-right noselect',
          thStyle: 'width:250px;padding-right: 5px;',
          tdClass: 'text-right align-middle p-0',
          formatter: x => this.$utils.numberToCurrency(x, settingsStore.settings['Centbetraege']),
          sortable: true
        },
        {
          key: 'Actions',
          label: 'Aktionen',
          thClass: 'align-top noselect',
          tdClass: 'text-center align-middle',
          thStyle: 'width: 100px'
        }
      ],
      newBudgetAllocationRecord: {},
      newBudgetAllocationPercentage: null,
      newBudgetAllocationAmount: null,
      sourcesWithBudget: [],
      costGroupTotalBudget: 0,
      costGroupAllocatedBudget: 0,
      tableIsBusy: true,
      loading: true,
      rowDataBackup: {}
    };
  },
  methods: {
    editComment(item) {
      this.currentAllocation = { ...item };
      this.$nextTick(() => {
        this.$bvModal.show('EditBudgetCommentModal');
      });
    },
    evalRowIsDirty(item) {
      // compare current values with backup values
      if (
        parseFloat(this.currentEditedRow.Amount) != parseFloat(this.rowDataBackup.Amount) ||
        parseFloat(this.currentEditedRow.Ratio) != parseFloat(this.rowDataBackup.Ratio)
      ) {
        this.rowIsDirty = item;
      } else {
        this.rowIsDirty = null;
      }
    },
    clickEveryWhereHandler(event) {
      console.log('zzz everywhere');
      if (
        (event.target &&
          event.target.viewportElement &&
          event.target.viewportElement.classList &&
          event.target.viewportElement.classList.contains('bi-x')) ||
        (event.target && event.target.classList && event.target.classList.contains('bi-x'))
      ) {
        console.log('zzz everywhere cancel');
        this.cancelRowEdit(this.currentEditedRow);
      } else if (this.currentEditedRow && event.target && event.target.id.includes(this.currentEditedRow.Id)) {
        //this.cancelRowEdit(this.currentEditedRow);
        //other cell in same line focused, no need to do anything
      } else if (
        (event.target &&
          event.target.viewportElement &&
          event.target.viewportElement.classList &&
          event.target.viewportElement.classList.contains('bi-check2')) ||
        (event.target && event.target.classList && event.target.classList.contains('bi-check2'))
      ) {
        this.updateAllocationItem(this.currentEditedRow);
      } else {
        if (this.currentEditedRow) {
          this.updateAllocationItem(this.currentEditedRow);
        }
      }
      //@click="updateAllocationItem(data.item)"
    },
    loadAllocations() {
      CostGroupsService.getCostGroupById(this.$route.params.id).then(result => {
        this.costGroupTotalBudget = parseFloat(result.Budget);
        this.currentCostGroup = result;
      });
      CostGroupsService.getCostGroupAllocations(this.$route.params.id)
        .then(results => {
          this.allocations = results.map(x => {
            x.Source = 'kke';
            x.Id = x.Source + x.RefDbId;
            x.editMode = false;
            x.Amount = parseFloat(x.Amount);
            x.Ratio = parseFloat((x.Amount / x.Budget) * 100).toFixed(1);
            return x;
          });
          this.recalcBudgetSum();
        })
        .catch(err => this.$showError(this, err.toString()))
        .finally(() => {
          this.tableIsBusy = false;
        });
    },
    loadAllocationUnitsWithBudget() {
      //if (!this.selectedSource) return;

      CostGroupsService.getBudgetSourcesWithBudget('ve')
        .then(results => {
          this.sourcesWithBudget = results.map(x => {
            x.DisplayText =
              x.Ordinal +
              ' ' +
              x.DisplayName +
              ' (' +
              this.$utils.numberToCurrency(x.BudgetSaldo, settingsStore.settings['Centbetraege']) +
              ')';
            return x;
          });
        })
        .catch(err => this.$showError(this, err.toString()));
    },
    deleteAllocation(item) {
      this.$bvModal
        .msgBoxConfirm('Soll die Budgetzuordnung wirklich gelöscht werden?', {
          title: 'Zuordnung löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          this.tableIsBusy = true;
          if (confirmed) {
            CostGroupsService.deleteAllocation(item)
              .then(() => {
                this.$utils.deleteItemFromArray(this.allocations, x => x.RefDbId == item.RefDbId);
                if (this.selectedSource) {
                  const sourceType = this.budgetSources.find(x => x.DbId == this.selectedSource);
                  if (item.Source == sourceType.DisplayText) {
                    this.refreshSourceEntries();
                  }
                }
                this.recalcBudgetSum();
                this.$showSuccess(this, 'Zuordnung löschen', 'Zuordnung erfolgreich gelöscht');
                this.$eventBus.$emit('budget:changed');
                console.log('zzz emitting it');
                if (this.allocations.length == 0) this.checkedAllCostGroups = false;
                this.loadAllocationUnitsWithBudget();
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
              })
              .finally(() => {
                this.tableIsBusy = false;
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    recalcBudgetSum() {
      this.costGroupAllocatedBudget = 0;

      for (const allocation of this.allocations) {
        //this.costGroupTotalBudget = allocation.Budget;
        this.costGroupAllocatedBudget += allocation.Amount;
      }
    },
    formatCurrency(number) {
      return this.$utils.numberToCurrency(number, settingsStore.settings['Centbetraege']);
    },
    editAllocation(item, fieldToFocus = null) {
      if (!(this.$root.$user.isPlaner || this.$root.$user.isAdmin)) return;
      this.fieldsBackup = JSON.parse(JSON.stringify(this.allocationsFields));
      this.allocationsFields.map(x => (x.sortable = false));
      item.editMode = true;
      this.currentEditedRow = item;
      this.rowDataBackup = { ...item };
      this.$nextTick(() => {
        if (fieldToFocus) {
          this.$refs[fieldToFocus + '-' + item.Id].focus();
        } else this.$refs['budgetAmountField-' + item.Id].focus();
      });
    },
    cancelRowEdit(item) {
      // set the field back to be sortable
      if (this.fieldsBackup)
        this.fieldsBackup.map(x => {
          if (x.sortable) {
            const item = this.allocationsFields.find(y => y.key == x.key);
            item.sortable = true;
          }
        });

      // user has canceled editing, so revert value fields to the state, they had before editMode.
      if (this.rowDataBackup) {
        item.Amount = this.rowDataBackup.Amount;
        item.Ratio = this.rowDataBackup.Ratio;
        this.rowDataBackup = null;
      }
      this.fieldsBackup = null;
      this.rowIsDirty = null;
      this.currentEditedRow = null;
      if (item) item.editMode = false;
    },
    updateAllocationItem(item) {
      if (!item || !this.rowIsDirty) return this.cancelRowEdit(item);
      //this.rowIsDirty = null;
      const input = this.$refs['budgetAmountField-' + item.Id];
      input.setCustomValidity(''); // remove current displayed notification

      // wenn die summe aller allokationen größer ist als das kke budget, dann nicht erlauben
      let allocatedBudgetSum = 0;
      let kkeBudget = 0;
      for (const allocation of this.allocations) {
        allocatedBudgetSum += parseFloat(allocation.Amount);
        kkeBudget = parseFloat(allocation.Budget);
      }

      if (item.Amount == '') {
        return input.reportValidity();
      }

      if (allocatedBudgetSum > kkeBudget) {
        input.setCustomValidity('KKE Budget überschritten.');
        return input.reportValidity();
      }

      if (item.Amount < 0) {
        input.setCustomValidity('Budget muss größer oder gleich 0 sein.');
        return input.reportValidity();
      }

      item.editMode = false;
      item.Amount = parseFloat(item.Amount);
      item.SourceDbId = item.KkeId;
      this.rowIsDirty = null;
      this.currentEditedRow = null;
      this.rowDataBackup = null;

      return CostGroupsService.updateAllocation(item)
        .then(() => {
          this.$showSuccess(this, 'Budgetierung bearbeiten', 'Budgetierung erfolgreich aktualisiert.');
          this.recalcBudgetSum();
          this.$eventBus.$emit('budget:changed');
        })
        .catch(err => {
          this.loadAllocations();
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    clearCustomValidity() {
      const input = this.$refs.allocationAmountField.$el;
      input.setCustomValidity('');
    },
    createBudgetAllocation() {
      const input = this.$refs.allocationAmountField.$el;
      input.setCustomValidity('');

      const allocation = {
        DbId: parseInt(this.$route.params.id),
        VeId: parseInt(this.newBudgetAllocationRecord.DbId),
        Amount: parseFloat(this.newBudgetAllocationAmount),
        sourceType: 'costgroups'
      };

      if (!this.$refs.newRecordForm.checkValidity()) {
        return this.$refs.newRecordForm.reportValidity();
      }

      if (this.costGroupAllocatedBudget + allocation.Amount > this.costGroupTotalBudget) {
        input.setCustomValidity('KKE Budget darf nicht überschritten werden!');
        return input.reportValidity();
      }

      if (allocation.Amount <= 0) {
        input.setCustomValidity('Die Zuordnung muss einen positiven Wert haben.');
        return input.reportValidity();
      }

      const source = this.sourcesWithBudget.find(x => x.DbId == this.newBudgetAllocationRecord.DbId);

      this.tableIsBusy = true;
      CostGroupsService.createAllocation(allocation)
        .then(result => {
          allocation.Ordinal = source.Ordinal;
          allocation.DisplayName = source.DisplayName;
          allocation.Budget = this.costGroupTotalBudget;
          allocation.Ratio = parseFloat((allocation.Amount / this.costGroupTotalBudget) * 100).toFixed(1);
          allocation.RefDbId = result.insertId;
          allocation.Source = 'kke';
          this.allocations.push(allocation);
          this.$showSuccess(this, 'Budget zuordnen', 'Budget erfolgreich zugeordnet.');
          this.$eventBus.$emit('budget:changed');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error.text);
          else this.$showError(this, err.toString());
        })
        .finally(() => {
          this.loadAllocationUnitsWithBudget();
          this.recalcBudgetSum();
          this.clearNewRecordFields();
          this.tableIsBusy = false;
        });
    },
    clearNewRecordFields() {
      this.newBudgetAllocationRecord = {};
      this.newBudgetAllocationPercentage = null;
      this.newBudgetAllocationAmount = null;
    },
    onEditRowRatioChanged(item) {
      item.Amount = (item.Budget * item.Ratio) / 100;
    },
    onEditRowValueChanged(item) {
      item.Ratio = parseFloat((item.Amount / item.Budget) * 100).toFixed(1);
    },
    onNewRecordRowPercentValueChanged() {
      this.newBudgetAllocationAmount =
        ((this.costGroupTotalBudget - this.costGroupAllocatedBudget) * this.newBudgetAllocationPercentage) / 100;
    },
    onNewRecordRowAmountValueChanged() {
      this.newBudgetAllocationPercentage = (
        (this.newBudgetAllocationAmount / (this.costGroupTotalBudget - this.costGroupAllocatedBudget)) *
        100
      ).toFixed(1);
    },
    onSourceChanged() {
      this.newBudgetAllocationPercentage = 100;
      this.newBudgetAllocationAmount = this.costGroupTotalBudget - this.costGroupAllocatedBudget;
    }
  },
  activated() {
    this.loadAllocations();
    this.loadAllocationUnitsWithBudget();
    this.clearNewRecordFields();
    document.addEventListener('mousedown', this.clickEveryWhereHandler, true);
  },
  deactivated() {
    document.removeEventListener('mousedown', this.clickEveryWhereHandler, true);
  }
};
</script>

<style scoped></style>
